/* eslint-disable */

export const createLinks = (data, clickedMethod, tv_radio = false) => {
    let size = data.length
    let i=0
    const external_domains = ['member.newsshell.com', 'member2.newsshell.com', 'newsclip.newsshell.com', 'newsclip2.newsshell.com', 'video.ryansmedia.com', 'video2.ryansmedia.com']
    let links = data.map((info) => {
        // check the link is drive or not
        const split_link = info[0].split("/")
        let is_drive = ((split_link[2] === 'drive.google.com') || (split_link[2] === 'www.youtube.com') || (split_link[2] === 'www.facebook.com')) ? true : false
        let is_external = external_domains.includes(split_link[2]) ? false : true
        let url = info[0]

        if(info[0].includes(process.env.REACT_APP_SEARCH_NEWSSHELL_DOMAIN)){
            url = info[0].replace(process.env.REACT_APP_SEARCH_NEWSSHELL_DOMAIN, process.env.REACT_APP_REPLACE_NEWSSHELL_DOMAIN)
        } else if((process.env.REACT_APP_SERVER_TYPE === 'secondary') && (info[0].includes(process.env.REACT_APP_SEARCH_NEWSSHELL_DOMAIN_2))){
            url = info[0].replace(process.env.REACT_APP_SEARCH_NEWSSHELL_DOMAIN_2, process.env.REACT_APP_REPLACE_NEWSSHELL_DOMAIN)
        } else if(info[0].includes(process.env.REACT_APP_SEARCH_VIDEO_DOMAIN)){
            url = info[0].replace(process.env.REACT_APP_SEARCH_VIDEO_DOMAIN, process.env.REACT_APP_REPLACE_VIDEO_DOMAIN)
        }

        i++
        return (
            <>
                {is_external ? (
                    <a href={url} target="_blank" className="px-1 text-primary cursor-pointer">
                        {info[1]}
                    </a>
                ):(
                    <span  
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => clickedMethod({url: url, media: info[1]})}
                        href={url} target="_blank" className="px-1 text-primary cursor-pointer single-alert-details">
                            {info[1]}
                    </span>
                )}
                
                { (i==size) ? "" : (<span style={{borderRight:"2px solid #A4A4A5"}}></span>)}
            </>
        );
    })
    return links
}